import React, { ReactElement } from "react";
import { Global, css } from "@emotion/react";

export const HeaderCssOverrides = (): ReactElement => {
  /**
   * CSS overrides description:
   * 1. MoreNav submenu position being aligned to right, to avoid overflow effect with menu item hanging outside and extending the layout width
   * 2. Fix "text-transform: uppercase" being added to MoreNav menu sub-items (where should be added only for top-level items)
   * 3. CSS for temporary id selector on top-level-item MenuItem when closeOnClick method triggers
   * 4. the same without :hover, for a keyboard navigation
   *
   * Those should be added to Spark's css in the future
   */

  return (
    <Global
      styles={css`
        /* Spark-React Header */
        .spark-header__more > ul {
          right: 0;
        }
        .spark-header__more .spark-menu__list .spark-menu__list {
          text-transform: none;
        }
        header.spark-header--visible
          .spark-menu
          > .spark-menu__list
          > .top-level-item#clicked-child:hover
          > .spark-menu__list {
          display: none;
        }
        header.spark-header--visible
          .spark-menu
          > .spark-menu__list
          > .top-level-item#clicked-child
          > .spark-menu__list {
          display: none;
        }
      `}
    />
  );
};

export const HeaderSecondaryNavCssOverrides = (): ReactElement => {
  /**
   * CSS overrides description:
   * 1. Fix positioning for secondaryNavigation menu
   * 2. Removes Classic's theme :after graphic element (shadow) for the last secondary navigation item (if  userBlock is not present), to prevent overflow layout issue
   * 3-6. Fix for secondaryNavigation submenu icons, not to inherit the styles of the top-level icon
   *
   * Those should be added to Spark's css in the future
   */

  return (
    <Global
      styles={css`
        /* Spark-React Header Secondary Nav */
        .spark-menu__list-item--secondary > ul {
          right: 0 !important;
        }
        .spark-header.spark-header--visible
          .spark-header__menu:last-child
          .spark-menu__list-item.spark-menu__list-item--secondary:last-child:after {
          display: none;
        }
        .spark-header.spark-header--visible
          .spark-menu__list-item.spark-menu__list-item--secondary
          .spark-menu__list-item
          .spark-menu__list-link
          [class^="spark-icon-"] {
          padding: 0;
          font-size: 1.33333333rem;
          line-height: 1.33333333rem;
        }
        .spark-header.spark-header--visible
          .spark-menu__list-item.spark-menu__list-item--secondary
          .spark-menu__list-item
          .spark-menu__list-link
          [class^="spark-icon-"]::before {
          font-size: inherit;
          line-height: inherit;
        }
        .spark-header.spark-header--visible
          .spark-menu__list-item.spark-menu__list-item--secondary
          .spark-menu__list-item
          .spark-menu__list-link:hover
          [class^="spark-icon-"] {
          background-color: transparent;
        }
        .spark-header.spark-header--visible
          .spark-menu__list-item.spark-menu__list-item--secondary
          .spark-menu__list-item
          .spark-menu__list-link:focus
          [class^="spark-icon-"] {
          box-shadow: none;
        }
      `}
    />
  );
};
